import instantsearch from 'instantsearch.js/dist/instantsearch.js';
import * as searcher from './searchWidgets'

const resultLimit = 3;
const userInput = '#dropKcSearchInput';
const defaultIndex = 'KnowledgePopular';
let reportSearch;
let toolSearch;
let projectSearch;
let alnProjectSearch;

/**
 * Set up and start the search on the knowledge center landing page
 */
if ($(userInput).length) {
    createSearch();
    initListeners();
    $(userInput).focus();
}

/**
 * Create and start a filtered InstantSearch search
 */
function createSearch() {
    reportSearch = searcher.getSearch(defaultIndex, resultLimit, false, 'Type:"Report"');
    toolSearch = searcher.getSearch(defaultIndex, resultLimit, false, 'Type:"Tool"');
    projectSearch = searcher.getSearch(defaultIndex, resultLimit, false, 'Type:"Project"');
    alnProjectSearch = searcher.getSearch(defaultIndex, resultLimit, false, 'Type:"ALNACC Resource"');

    reportSearch.addWidget(searcher.widgetInput(userInput));
    toolSearch.addWidget(searcher.widgetInput(userInput));
    projectSearch.addWidget(searcher.widgetInput(userInput));
    alnProjectSearch.addWidget(searcher.widgetInput(userInput));

    reportSearch.addWidget(searcher.widgetDropHits('#hitsReports'));
    toolSearch.addWidget(searcher.widgetDropHits('#hitsTools'));
    projectSearch.addWidget(searcher.widgetDropHits('#hitsProjects'));
    alnProjectSearch.addWidget(searcher.widgetDropHits('#hitsAlnProjects'));

    reportSearch.start();
    toolSearch.start();
    projectSearch.start();
    alnProjectSearch.start();
}

/**
 * Sets up listeners for various sections of the search page to
 * give a more interactive and useful search experience.
 */
function initListeners() {
    $('#allReports').click(function() {
        $('#allReports').prop('href', 'KnowledgeCentreSearch?term=' +
            $(userInput).val() + '&dFR%5BType%5D%5B0%5D=Report');
    });

    $('#allTools').click(function() {
        $('#allTools').prop('href', 'KnowledgeCentreSearch?term=' +
            $(userInput).val() + '&dFR%5BType%5D%5B0%5D=Tool');
    });

    $('#allProjects').click(function() {
        $('#allProjects').prop('href', 'KnowledgeCentreSearch?term=' +
            $(userInput).val() + '&dFR%5BType%5D%5B0%5D=Project');
    });

    $('#allAlnProjects').click(function() {
        $('#allAlnProjects').prop('href', 'KnowledgeCentreSearch?term=' +
            $(userInput).val() + '&dFR%5BType%5D%5B0%5D=ALNACC%20Resource');
    });

    $('#knowledgeSearchInput').on('submit', (e) => {
        window.location.href =
            '../KnowledgeCentreSearch?term=' + $(userInput).val();
        e.preventDefault();
    });
}



// WEBPACK FOOTER //
// ./src/js/search/knowledgeDropSearch.js